import { Text } from "@components/Text";
import styles from "./index.module.css";
import type { FC, ReactNode } from "react";

type Props = {
  title: string;
  children: ReactNode;
  toolTip?: ReactNode;
};

export const ReservationFormRow: FC<Props> = ({ title, children, toolTip }) => {
  return (
    <dl>
      <dt className={styles.title}>
        <Text size={14} bold>
          {title}
        </Text>
        {toolTip}
      </dt>
      <dd>{children}</dd>
    </dl>
  );
};
